import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { OutsideClick } from '../../Defaults/OutsideClick';
import { FlexColCenter } from '../../Defaults/Flexbox/Flexbox';

export interface Props {
  handleClose: any;
  children: any;
}

function ModalWrapper({ handleClose, children }: Props) {
  return (
    <Wrapper>
      <ModalStyle />
      <ModalHolder>
        <OutsideClickWrapper>
          <OutsideClick handleFunction={handleClose}>{children}</OutsideClick>
        </OutsideClickWrapper>
      </ModalHolder>
    </Wrapper>
  );
}

const OutsideClickWrapper = styled.div`
  width: 100%;
  max-width: ${rem(656)};
`;

const Wrapper = styled.div``;

const ModalHolder = styled(FlexColCenter)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.index.modal};
`;

const ModalStyle = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.2;
  z-index: ${({ theme }) => theme.index.modal};
`;

export { ModalWrapper };
